import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseHoursReportsKey } from '@/hooks'
import { APIErrorResponse, HoursReport, PatchHoursReport } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export type UsePatchHoursReportProps = {
  id: number
}

export const usePatchHoursReport = ({
  id,
}: UsePatchHoursReportProps): UseMutationResult<
  HoursReport,
  APIErrorResponse,
  PatchHoursReport
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const hoursReportsListKey = getUseHoursReportsKey()

  return useMutation(
    (params) =>
      client
        .patch(`/hours_reporting/hr/${id}/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(hoursReportsListKey)
      },
    }
  )
}
